import React from 'react';
import styled, { keyframes } from 'styled-components';
import cn from 'classnames';
import { isIE } from '../../__utils__/browserUtils';
var ANIMATION_INTERVAL = 1000; // milliseconds

var ARC_SIZE_MAX = 300; // degrees

var ARC_SIZE_MIN = 20;
var sizing = {
  small: 22,
  medium: 40,
  large: 60
};

var calcRadius = function calcRadius(size) {
  return 9 * (sizing[size] / 20.0);
};
/**
 * A dynamic spinning animation to indicate loading/processing.
 */


export var ProgressSpinner = function ProgressSpinner(_ref) {
  var className = _ref.className,
      label = _ref.label,
      size = _ref.size;
  var isBrowserIE = isIE();
  var viewBoxSize = sizing[size];
  return React.createElement("div", {
    className: cn('bbui-progress-spinner', className)
  }, !isBrowserIE && React.createElement("div", {
    className: "spinner"
  }, React.createElement("div", {
    className: "rotation"
  }, React.createElement("div", {
    className: "oscillation"
  }, React.createElement("svg", {
    height: viewBoxSize,
    width: viewBoxSize,
    viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize)
  }, React.createElement("circle", {
    className: "arc",
    cx: viewBoxSize / 2,
    cy: viewBoxSize / 2,
    r: calcRadius(size),
    fill: "none",
    stroke: "currentColor",
    strokeWidth: viewBoxSize / 10
  }))))), label && !isBrowserIE && React.createElement("div", {
    className: "label"
  }, label), isBrowserIE && React.createElement("div", {
    className: "label"
  }, "Loading..."));
};
ProgressSpinner.defaultProps = {
  className: '',
  size: 'small',
  labelPosition: 'bottom'
};

var getFlexDirection = function getFlexDirection(position) {
  if (position === 'top') {
    return 'column-reverse';
  }

  if (position === 'bottom') {
    return 'column';
  }

  if (position === 'left') {
    return 'row-reverse';
  }

  return 'row';
};

var getMarginDirection = function getMarginDirection(position) {
  if (position === 'top') {
    return 'margin-bottom';
  }

  if (position === 'bottom') {
    return 'margin-top';
  }

  if (position === 'left') {
    return 'margin-right';
  }

  return 'margin-left';
};

var spin = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var oscillate = keyframes(["from{transform:rotate(200deg);}to{transform:rotate(10deg);}"]);

var calcArcLength = function calcArcLength(size, angle) {
  return Math.PI * calcRadius(size) * (360 - angle) / 180.0;
};

var makeInitialArcGrowthIntro = function makeInitialArcGrowthIntro(size) {
  return keyframes(["from{stroke-dashoffset:", ";}to{stroke-dashoffset:", ";}"], calcArcLength(size, 0), calcArcLength(size, ARC_SIZE_MAX));
};

var makeGrowAndShrinkKeyframes = function makeGrowAndShrinkKeyframes(size) {
  return keyframes(["from{stroke-dashoffset:", ";}to{stroke-dashoffset:", ";}"], calcArcLength(size, ARC_SIZE_MIN), calcArcLength(size, ARC_SIZE_MAX));
};

var StyledProgressSpinner = styled(ProgressSpinner).withConfig({
  displayName: "ProgressSpinner__StyledProgressSpinner",
  componentId: "sc-621eyt-0"
})(["display:flex;align-items:center;flex-direction:", ";> .spinner{display:block;position:relative;overflow:hidden;width:", "px;height:", "px;& .rotation{position:absolute;height:100%;width:100%;animation:", " ", "ms infinite linear;& .oscillation{position:absolute;width:100%;height:100%;animation:", " ", "ms infinite ease-in-out;animation-direction:alternate;& .arc{stroke-dashoffset:", ";stroke-dasharray:", ";animation-name:", ",", ";animation-duration:", "ms,", "ms;animation-delay:0,", "ms;animation-timing-function:ease-in-out,ease-in-out;animation-iteration-count:1,infinite;animation-direction:normal,alternate;color:", ";}}}}> .label{", ":.75em;font-size:", ";}"], function (props) {
  return getFlexDirection(props.labelPosition);
}, function (_ref2) {
  var size = _ref2.size;
  return sizing[size];
}, function (_ref3) {
  var size = _ref3.size;
  return sizing[size];
}, spin, ANIMATION_INTERVAL, oscillate, ANIMATION_INTERVAL, function (_ref4) {
  var size = _ref4.size;
  return calcArcLength(size, 10);
}, function (_ref5) {
  var size = _ref5.size;
  return 2 * Math.PI * calcRadius(size);
}, function (_ref6) {
  var size = _ref6.size;
  return makeInitialArcGrowthIntro(size);
}, function (_ref7) {
  var size = _ref7.size;
  return makeGrowAndShrinkKeyframes(size);
}, ANIMATION_INTERVAL, ANIMATION_INTERVAL, ANIMATION_INTERVAL, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.info.graphic;
}, function (props) {
  return getMarginDirection(props.labelPosition);
}, function (props) {
  return props.theme.font.size[props.size];
});
StyledProgressSpinner.defaultProps = ProgressSpinner.defaultProps;
export default StyledProgressSpinner;